module.exports = __webpack_public_path__ + "img/Unix Systems.fb002781.png";